import Splide from '@splidejs/splide';
import { initNewsroomArticleYtPlayer } from '../../../snippets/article-newsroom-ytplayer/article-newsroom-ytplayer';

export const initArticleVideos = () => {
  const previewImages = document.querySelectorAll('img[alt^="video-id-"]');

  if (previewImages.length) {
    previewImages.forEach((image) => {
      const videoId = image.getAttribute('alt').trim().split('video-id-')[1];

      if (videoId) {
        image.insertAdjacentHTML(
          'beforebegin',
          `
        <div class="article-newsroom__preview-img"
            data-video-id="${videoId}"
            data-video-name=="${videoId}"
            data-video-action
        >
            ${image.outerHTML}
            <span class="article-newsroom__play-icon"></span>
        </div>
      `
        );
        image.remove();
      }
    });
  }

  initNewsroomArticleYtPlayer('[data-video-action]');
};

export const initArticleCarousel = () => {
  const images = document.querySelectorAll('img[alt^="carousel-"]');
  const slides = [];

  if (images.length) {
    images[0].insertAdjacentHTML(
      'beforebegin',
      `
        <div class="article-newsroom__carousel splide"
            data-article-carousel
        >
          <div class="article-newsroom__carousel-track splide__track">
            <div class="article-newsroom__carousel-slides splide__list"
            data-article-carousel-list
            ></div>
          </div>
        </div>
    `
    );

    images.forEach((image) => {
      const slide = document.createElement('div');

      slide.classList.add('article-newsroom__carousel-slide', 'splide__slide');
      slide.append(image);
      slides.push(slide);
    });

    const carouselWp = document.querySelector('[data-article-carousel]');
    const carouselList = document.querySelector('[data-article-carousel-list]');

    carouselList.append(...slides);

    new Splide(carouselWp, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      speed: 500,
      rewind: true,
      arrows: true,
      pagination: false,
      classes: {
        arrows: 'article-newsroom__carousel-arrows splide__arrows',
        arrow: 'article-newsroom__carousel-arrow splide__arrow',
        prev: 'article-newsroom__carousel-arrow--prev splide__arrow--prev',
        next: 'article-newsroom__carousel-arrow--next splide__arrow--next',
      },
    }).mount();
  }
};
